import { httpClient } from '@/modules/common/services/http/http-client';
import {
  BalancesResponse,
  IExperienceResponse,
  IUpdateCustomerExperienceResponse,
  HomeStatementsResponse,
  INotifications,
  NewsResponse,
  TotalBalanceResponse
} from './types';

const http = httpClient.withOptions({
  baseURL: `${process.env.VUE_APP_BFF_URL}/banking/v1/home`
});

const httpConsolidation = httpClient.withOptions({
  baseURL: `${process.env.VUE_APP_BFF_URL}/consolidation`
});

export function getNews(customerId: string): Promise<NewsResponse> {
  return http.get('/getNews', { params: { customerId } });
}

export function getCustomerExperience(
  brandId: string | undefined
): Promise<IExperienceResponse> {
  return http.get('/getCustomerExperience', { params: { brandId } });
}

export function updateCustomerExperience(
  name: string
): Promise<IUpdateCustomerExperienceResponse> {
  return http.put('/updateCustomerExperience', { name });
}

export function getStatements(): Promise<HomeStatementsResponse> {
  return http.get('/statements');
}

export function getBalances(): Promise<BalancesResponse> {
  return http.get('/balances');
}

export function getTotalBalance(): Promise<TotalBalanceResponse> {
  return httpConsolidation.get('/v1/balance/total');
}

export function getNotifications(): Promise<INotifications> {
  return http.get('/notifications');
}
